

























// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore } from 'aws-amplify'
import { query as tenant } from '@/store/tenant'
import { mutateSnackbar } from '@/store/snackbar'
import Editor from '@/components/Editor.vue'
import { RowConfig } from '@/lib/RowConfig.interface'
import { Page } from '../models/index'
import { copyFromDataStore } from '@/amplify'

@Component<PageEditView>({
  components: {
    Editor
  },
  // @ts-ignore
  metaInfo() {
    let name = ``
    // @ts-ignore
    if (this.page?.title && this.page.title[this.$i18n.locale]) {
      // @ts-ignore
      name = this.page.title[this.$i18n.locale]
    }
    return {
      title: this.$t('pageEdit.titleNamed', {
        name
      })
    }
  },
  apollo: {
    tenant
  }
})
export default class PageEditView extends Vue {
  page = null
  label: string = ``
  isPreviewVisible = false
  isLoading = false

  @Watch('pageId', { immediate: true })
  refetchPage() {
    this.getPage()
  }

  async getPage() {
    this.isLoading = true
    try {
      const query = await DataStore.query(Page, this.pageId)
      if (!query) throw new Error('Page not found')
      this.page = copyFromDataStore(query)
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }

  get editorRows(): RowConfig[] {
    return [
      { title: this.$t('pageEdit.contentTitle'), type: 'title', key: 'title' },
      { title: this.$t('pageEdit.content'), type: 'text', key: 'content' }
    ]
  }

  get pageId() {
    return this.$route.params.pageId
  }

  async savePage() {
    this.isLoading = true
    try {
      await DataStore.save(
        Page.copyOf(
          await DataStore.query(Page, this.pageId),
          updated => {
            for (const [key, value] of Object.entries(this.page)) {
              updated[key] = value
            }
          }
        )
      )
      mutateSnackbar(
        { text: String(`Erfolgreich gespeichert`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }
}
